import React, { useContext, useEffect, useState } from "react";
import Slider from "../../components/slider/Slider";
import { NavLink } from "react-router-dom";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import { Navigation, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { CiLocationOn } from "react-icons/ci";
import { FcCalendar } from "react-icons/fc";
import { FcClock } from "react-icons/fc";
import { toast } from "react-toastify";
import "./home.css";
import { AxiosError } from "axios";
import { FaLongArrowAltRight } from "react-icons/fa";

// import Clipboard from "clipboard";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
// import { BiCopy } from "react-icons/bi";
// import Location from "../../Location";
import Aos from "aos";
import { server, truncateText } from "../../common";
import configContext from "../../context/configContext/configContext";
import About from "../About/About";

const Home = () => {
  const [events, setEvents] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [superadminmerchants, setSuperadminMerchants] = useState([]);
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);
  const [news, setNews] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [testinomial, settestinomial] = useState([]);

  const [stats, setStats] = useState({
    projects: 0,
    clients: 0,
    years: 0,
    solutions: 0,
  });

  // Simulated counter animation
  useEffect(() => {
    const finalStats = {
      years: 5,
      members: 25532,
      programs: 18,
      volunteers: 2713,
    };
    const duration = 2000; // 2 seconds
    const frameDuration = 20; // 20ms per frame
    const totalFrames = duration / frameDuration;
    let frame = 0;

    const timer = setInterval(() => {
      frame++;
      const progress = frame / totalFrames;

      setStats({
        programs: Math.floor(progress * finalStats.programs),
        members: Math.floor(progress * finalStats.members),
        years: Math.floor(progress * finalStats.years),
        volunteers: Math.floor(progress * finalStats.volunteers),
      });

      if (frame === totalFrames) {
        clearInterval(timer);
        setStats(finalStats);
      }
    }, frameDuration);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    getData();
    getMerchants();
    getNews();
    getPrograms();
    getTestinomial();
  }, []);

  // const events = [
  //   {
  //     id: 1,
  //     url: "/events/e (1).jpeg",
  //     title: "Mechanical Alloying Of Nano Composites",
  //     location:
  //       "Gnanamani College of Technology, NH-7, A.K.Samuthiram, Pachal-PO, Namakkal-637 018.",
  //     link: "https://maps.app.goo.gl/YkGXCPB6QFGK92456",
  //     time: "11 AM to 12.15 PM",
  //     event_date: "7 September",
  //     city: "Pune",
  //   },
  //   {
  //     id: 2,
  //     url: "/events/e (2).jpeg",
  //     title: "National Level Technical Symposium And Workshop",
  //     city: "Delhi",
  //     location:
  //       "K.S.R. College of Engineering, K.S.R. Kalvi Nagar, Tiruchengode - 637 215, Namakkal (D.t)",
  //     event_date: "10 March",
  //     time: "11 AM to 1.00 PM",
  //     link: "https://maps.app.goo.gl/cfx8ZfaPosHVDt6w6",
  //   },
  //   {
  //     id: 3,
  //     url: "/events/e (3).jpeg",
  //     title: "A National Level Techno, Cultural Literacy and Sport Fest",
  //     city: "Delhi",
  //     event_date: "23rd to 25th October 2019",
  //     location: "Parvathapur, Uppal, Hydrabad - 500098",
  //     time: "2.00 PM to 4.00 PM",
  //   },
  //   {
  //     id: 4,
  //     url: "/events/e (4).jpeg",
  //     title: "A National Level Inter-College Technical Symposium",
  //     event_date: "10th January 2020",
  //     location:
  //       "KCG Nagar, Rajiv Gandhi Salai, Karapakkam, Chennai – 600 097. Tamil Nadu. India.",
  //     city: "Goa",
  //     time: "3.00 PM to 7.00 PM",
  //   },
  //   {
  //     id: 5,
  //     url: "/events/e (5).jpeg",
  //     title: "19th Technotsav 2020",
  //     event_date: "19th Feb 2020",
  //     city: "Delhi",
  //     location:
  //       "Facing Main Road, Sheriguda , Ibrahimpatan, R.R Dist. 501 510.",
  //     time: "1.00 PM to 5.00 PM",
  //   },
  //   {
  //     id: 6,
  //     url: "/events/e (6).jpeg",
  //     title: "A National Level Technical Symposium",
  //     city: "Delhi",
  //     event_date: "19th Feb, 2020",
  //     location:
  //       "Facing Main Road, Sheriguda , Ibrahimpatan, R.R Dist. 501 510.",
  //     time: "9.00 AM to 12.00 PM",
  //   },
  //   {
  //     id: 7,
  //     url: "/events/e (7).jpeg",
  //     title: "A National Level Technical Symposium",
  //     city: "Goa",
  //     location:
  //       "Facing Main Road, Sheriguda , Ibrahimpatan, R.R Dist. 501 510.",
  //     event_date: "19th & 20th Feb, 2020",
  //     time: "10.00 AM to 2.00 PM",
  //   },
  // ];

  // const getMerchants = () => {
  //   server
  //     .get("/job/getalljobs", {
  //       headers: {
  //         "Content-Type": "application/json",
  //         // "auth-token": user.authToken,
  //       },
  //     })
  //     .then(function (response) {
  //       console.log("api response", response.data);
  //       if (response.status === 200 || response.status === 201) {
  //         setMerchants(response.data);
  //       }
  //     })
  //     .catch(function (error) {
  //       if (error instanceof AxiosError && error.response?.data?.message)
  //         toast.error(error.response.data.message);
  //       else if (error.response?.data?.error) {
  //         toast.error(error.response.data.error);
  //       } else toast.error("Failed to connect to server");
  //     });
  // };

  // Get  events

  // Get
  const getNews = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/news/getallnews", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setNews(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  const getData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/event/getallevent", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setEvents(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  const getMerchants = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/shopdetails/getallshop_details", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setMerchants(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  // const events = [
  //   {
  //     id: 1,
  //     url: "/events/e (1).jpeg",
  //     title: "Mechanical Alloying Of Nano Composites",
  //     location:
  //       "Gnanamani College of Technology, NH-7, A.K.Samuthiram, Pachal-PO, Namakkal-637 018.",
  //     link: "https://maps.app.goo.gl/YkGXCPB6QFGK92456",
  //     time: "11 AM to 12.15 PM",
  //     event_date: "7 September",
  //     city: "Pune",
  //   },
  //   {
  //     id: 2,
  //     url: "/events/e (2).jpeg",
  //     title: "National Level Technical Symposium And Workshop",
  //     city: "Delhi",
  //     location:
  //       "K.S.R. College of Engineering, K.S.R. Kalvi Nagar, Tiruchengode - 637 215, Namakkal (D.t)",
  //     event_date: "10 March",
  //     time: "11 AM to 1.00 PM",
  //     link: "https://maps.app.goo.gl/cfx8ZfaPosHVDt6w6",
  //   },
  //   {
  //     id: 3,
  //     url: "/events/e (3).jpeg",
  //     title: "A National Level Techno, Cultural Literacy and Sport Fest",
  //     city: "Delhi",
  //     event_date: "23rd to 25th October 2019",
  //     location: "Parvathapur, Uppal, Hydrabad - 500098",
  //     time: "2.00 PM to 4.00 PM",
  //   },
  //   {
  //     id: 4,
  //     url: "/events/e (4).jpeg",
  //     title: "A National Level Inter-College Technical Symposium",
  //     event_date: "10th January 2020",
  //     location:
  //       "KCG Nagar, Rajiv Gandhi Salai, Karapakkam, Chennai – 600 097. Tamil Nadu. India.",
  //     city: "Goa",
  //     time: "3.00 PM to 7.00 PM",
  //   },
  //   {
  //     id: 5,
  //     url: "/events/e (5).jpeg",
  //     title: "19th Technotsav 2020",
  //     event_date: "19th Feb 2020",
  //     city: "Delhi",
  //     location:
  //       "Facing Main Road, Sheriguda , Ibrahimpatan, R.R Dist. 501 510.",
  //     time: "1.00 PM to 5.00 PM",
  //   },
  //   {
  //     id: 6,
  //     url: "/events/e (6).jpeg",
  //     title: "A National Level Technical Symposium",
  //     city: "Delhi",
  //     event_date: "19th Feb, 2020",
  //     location:
  //       "Facing Main Road, Sheriguda , Ibrahimpatan, R.R Dist. 501 510.",
  //     time: "9.00 AM to 12.00 PM",
  //   },
  //   {
  //     id: 7,
  //     url: "/events/e (7).jpeg",
  //     title: "A National Level Technical Symposium",
  //     city: "Goa",
  //     location:
  //       "Facing Main Road, Sheriguda , Ibrahimpatan, R.R Dist. 501 510.",
  //     event_date: "19th & 20th Feb, 2020",
  //     time: "10.00 AM to 2.00 PM",
  //   },
  // ];

  // const getMerchants = () => {
  //   server
  //     .get("/job/getalljobs", {
  //       headers: {
  //         "Content-Type": "application/json",
  //         // "auth-token": user.authToken,
  //       },
  //     })
  //     .then(function (response) {
  //       console.log("api response", response.data);
  //       if (response.status === 200 || response.status === 201) {
  //         setMerchants(response.data);
  //       }
  //     })
  //     .catch(function (error) {
  //       if (error instanceof AxiosError && error.response?.data?.message)
  //         toast.error(error.response.data.message);
  //       else if (error.response?.data?.error) {
  //         toast.error(error.response.data.error);
  //       } else toast.error("Failed to connect to server");
  //     });
  // };

  // Get  events

  // Get
  const getPrograms = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/program/getallprogram", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setPrograms(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  const getTestinomial = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/testimonials/getalltestimonials", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          settestinomial(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  // const programs = [
  //   {
  //     title: "दिनदर्शिका लोकार्पण सोहळा",
  //     date: "13 Octomber 2024",
  //     description:
  //       "मराठवाडा सामाजिक फाउंडेशनच्यावतीने आयोजित दिनदर्शिका लोकार्पण सोहळा ही दिनदर्शिका आपल्या मराठवाडा संस्कृतीचे, एकात्मतेचे व सामाजिक बांधिलकीचे प्रतीक आहे.",
  //     image: "/satkar/DSC_0171.JPG",
  //   },
  //   {
  //     title: " विद्यार्थ्यांना टी-शर्टचे वाटप",
  //     date: "13 Octomber 2024",
  //     description:
  //       "लहान विद्यार्थ्यांसाठी विविध स्पर्धांचे आयोजन करण्यात आले. या स्पर्धांद्वारे खेळातील सहभागाला प्रोत्साहन मिळावे आणि मराठवाड्यातील मुलेही खेळाच्या क्षेत्रात उजवी ठरावीत, या उद्देशाने या स्पर्धा घेण्यात आल्या.",
  //     image: "/satkar/WhatsApp Image 2025-06-14 at 4.45.46 PM.jpeg",
  //   },
  //   {
  //     title: "दसरा मेळावा ",
  //     date: "13 Octomber 2024",
  //     description:
  //       "नाशिक येथे भव्य दसरा मेळाव्याचे आयोजन करण्यात आले होते. विविध सांस्कृतिक कार्यक्रम, व्याख्याने, आणि समाज प्रबोधनपर उपक्रमांद्वारे हा मेळावा सामाजिक एकात्मतेचा संदेश देनारा ठरला.",
  //     image: "/satkar/DSC_0045.JPG",
  //   },
  //   {
  //     title: "गुणवंत विद्यार्थी सत्कार सोहळा ",
  //     date: "2 May 2025",
  //     description:
  //       "२०२३ मध्ये शिक्षण क्षेत्रात उत्तुंग यश मिळवलेल्या गुणवंत विद्यार्थ्यांचा भव्य सत्कार समारंभ आयोजित करण्यात आला.",
  //     image: "/satkar/DSC_9071.JPG",
  //   },
  //   {
  //     title: "मकरसंक्रांती हळदी कुंकू ",
  //     date: "14 Jan 2024",
  //     description:
  //       "मकर संक्रांतीनिमित्त महिलांसाठी हळदीकुंकवाचा पारंपरिक कार्यक्रम आयोजित करण्यात आला. ",
  //     image: "/satkar/490133046_2089701674775414_4675277838334667859_n.jpg",
  //   },

  //   {
  //     title: "अनाथ आश्रमात शैक्षणिक साहित्य वाटप",
  //     date: "14 Jan 2024",
  //     description: "वंचित कुटुंबांसाठी मोफत आरोग्य तपासणी केली.",
  //     image: "/satkar/WhatsApp Image 2025-06-14 at 3.21.03 PM.jpeg",
  //   },
  // ];

  // const testimonials = [
  //   {
  //     name: "सौ. मेघना साकोरे-बोर्डीकर",
  //     role: "राज्यमंत्री,महाराष्ट्र शासन",
  //     feedback:
  //       "मराठवाडा सामाजिक फाऊंडेशन मागील काही वर्षांपासून मराठवाडा हा सुजलाम-सुफलाम व्हावा, या दृष्टिकोनातून सातत्याने कार्यरत आहे. मुंबई, पुणे, नाशिक, नागपूर या महानगरांमध्ये मराठवाड्यातून स्थलांतर करून स्थायिक झालेल्या लाखो नागरिकांसाठी हे फाऊंडेशन एक विश्वासार्ह व हक्काचं व्यासपीठ ठरलं आहे. या संस्थेचं कार्य निश्चितच समाजाला नवी दिशा देणारं असून, त्यांचे उपक्रम प्रशंसनीय आहेत.",
  //     avatar: "/images/meghana.jpg",
  //   },
  //   {
  //     name: "मा.श्री राजेभाऊ (पराग) वाजे ",
  //     role: "खासदार  नाशिक लोकसभा",
  //     feedback:
  //       "मराठवाड्यातील नागरीक नाशिक शहरात लाखोंच्या संख्येने राहत आहेत. त्यांच्या अडचणीच्या वेळी, मराठवाडा सामाजिक फाऊंडेशन काम करत आहे याचा मला अभिमान आहे. तसेच मराठवाड्यातील नाशिक मध्ये  राहत असलेल्या नागरिकांसाठी नाशिकचा खासदार या नात्याने व  माझी ही मराठवाड्यात नाळ जुळल्या मुळे मी फाऊंडेशनला जे काही सहकार्य लागेल ते नक्कीच करेल.",
  //     avatar: "/images/vaje.png",
  //   },
  //   {
  //     name: "मा.श्री. डी. एल. कराड",
  //     role: "राष्ट्रीय उपाध्यक्ष – CITU तथा कामगार नेते ",
  //     feedback:
  //       "मराठवाडा सामाजिक फाऊंडेशन ने नाशिक, पुणे, मुंबई, नागपूर व इतर शहरांमध्ये स्थलांतरित झालेल्या युवक-युवतींना व महिलांना नोकरी, व्यवसाय व पूरक उत्पन्नाच्या संधी उपलब्ध करून दिल्या आहेत. अडचणीच्या काळात या फाऊंडेशनने सुख-दुःखात साथ देत सर्वांना मोलाचे सहकार्य केले आहे. मराठवाड्यातून शहरांमध्ये स्थलांतरित होणाऱ्या प्रत्येक व्यक्तीच्या मनात शहरात आल्यावर सर्वप्रथम आठवण होते ती मराठवाडा सामाजिक फाऊंडेशन चीच – हे या संस्थेचे खरे यश आहे.",
  //     avatar: "/images/karad.png",
  //   },
  //   {
  //     name: "मा.श्री. प्रदीप पेशकार",
  //     role: "सदस्य, नॅशनल बोर्ड MSME , भारत सरकार  ",
  //     role2: "प्रदेश प्रवक्ते – भारतीय जनता पार्टी, महाराष्ट्र",
  //     feedback:
  //       "मराठवाडा सामाजिक फाऊंडेशन हे मराठवाड्याच्या सर्वांगीण विकासासाठी कटिबद्ध आहे. विशेषतः दुष्काळग्रस्त भागातून स्थलांतरित झालेल्या नागरिकांसाठी—जसे की विद्यार्थी, कामगार, उद्योजक, नोकरदार, महिला, आणि व्यावसायिक—यांना भेडसावणाऱ्या अडचणींवर मात करण्यासाठी हे फाऊंडेशन सातत्याने कार्यरत आहे. सहकार्यातून राष्ट्रनिर्माण हे या फाऊंडेशनचे प्रमुख ध्येय असून, निश्चितच हे संस्थान भविष्यात राष्ट्रसेवेस अधिकाधिक योगदान देईल, असा मला विश्वास आहे. पुढील वाटचालीस माझ्या मनःपूर्वक शुभेच्छा",
  //     avatar: "/images/pradip.png",
  //   },
  //   {
  //     name: "मा.श्री लक्ष्मणरावजी सावजी",
  //     role: "प्रदेश प्रवक्ते – भारतीय जनता पार्टी, महाराष्ट्र",
  //     feedback:
  //       "मराठवाडा सामाजिक फाऊंडेशन ने केवळ मराठवाड्यातच नव्हे, तर संपूर्ण महाराष्ट्रभर स्थलांतरित झालेल्या मराठवाड्यातील नागरिकांना एकत्रित करून सामाजिक बांधिलकी जपण्याचे प्रेरणादायी कार्य केले आहे. नाशिक शहरात जसा 'खानदेश महोत्सव' साजरा होतो, त्याच धर्तीवर 'मराठवाडा महोत्सवा'चा आरंभ निश्चितच व्हावा, यासाठी माझ्याकडून पूर्ण सहकार्य राहील. संपूर्ण भारतात आणि त्यातल्या त्यात महाराष्ट्रात.. मराठवाड्याला विशेष महत्त्व आहे. मराठवाड्याचे पौराणिक, ऐतिहासिक, सामाजिक तसेच राजकीय महत्त्व अनन्यसाधारण आहे..!",
  //     avatar: "/images/savji.png",
  //   },
  //   {
  //     name: "मा.श्री लक्ष्मण सावळकर",
  //     role: "संस्थापक आणि संचालक मॅग्नस फार्म फ्रेश लिमिटेड, नाशिक",
  //     feedback:
  //       "मराठवाडा हा भाग नेहमीच दुष्काळग्रस्त राहिला आहे. त्यामुळे मराठवाड्यातील शेतकरी, कामगार आणि इतर घटक हळूहळू शहरांकडे स्थलांतरित होत आहेत. मात्र, शेतकऱ्यांनी शेतीकडे व्यवसायिक दृष्टिकोनातून पाहण्याची गरज आहे. मराठवाडा सामाजिक फाऊंडेशन शहरांमध्ये आलेल्या नागरिकांचे एकत्रीकरण करण्याचे मोलाचे कार्य करत आहे. हे कार्य समाजहितासाठी अत्यंत आवश्यक असून, एकमेकांच्या सहकार्याने नक्कीच सकारात्मक बदल घडवून आणता येईल. माझ्या कडून जे काही शक्य होईल, ती मदत मी नक्की करीन. मराठवाडा सामाजिक फाऊंडेशनच्या भावी वाटचालीस मनःपूर्वक शुभेच्छा!",
  //     avatar: "/images/lakshaman.jpeg",
  //   },
  //   {
  //     name: "श्री. अजय विष्णु आघाव",
  //     role: "शहराध्यक्ष, भाजपा ओबीसी मोर्चा, नाशिक",
  //     feedback:
  //       "मराठवाडा म्हणजे अति दुर्गम दुष्काळी,ऊसतोड कामगारांचा भाग आहे शहरात आल्यावर आपल्या हक्काच्या मानसाची गरज पडते आणि तीच गरज मराठवाडा सामाजिक फाऊंडेशन ने नाशिक ,पुणे ,मुंबई ,नागपूर व इतर  शहरांमध्ये  स्थलांतरित झालेल्या युवक व महीला, साठी नोकरी , व्यवसाय, जोडधंदा उपलब्ध करून दिला. त्याच प्रमाणे गेले दोन वर्षांपासून दसरा मेळावा साजरा करुन मराठवाड्यातील लोकांना एकत्र करून खुप चांगले संघटन उभा केले आहे  एकमेकांच्या सुख दुःखात सहभागी होऊन सर्वांना सहकार्य करत आहेत  मराठवाड्यातून स्थलांतरित मोठ्या शहरात आल्यानंतर नाव आठवतं ते पहिलं  म्हणजे मराठवाडा सामाजिक फाऊंडेशन",
  //     avatar: "/team/t4.jpeg",
  //   },
  //   {
  //     name: "मा.श्री.डॉ. संजय रोडगे ",
  //     role: "अध्यक्ष श्रीराम प्रतिष्ठान",
  //     feedback:
  //       "मराठवाड्यातील मुलांना शिकवण्यासाठी आणि व उत्तम दर्जाचे चांगले शिक्षण देण्यासाठी श्रीराम प्रतिष्ठानच्या माध्यमातून सर्व प्रकारचे शिक्षण सोयी, सुविधा सह  मिळावे यासाठी प्रयत्न करण्यात आले आहे. मराठवाडा सामाजिक फाऊंडेशन च्या माध्यमातून मराठवाड्यातून बाहेर पडलेल्या विद्यार्थ्यांना ज्या काही अडचणीचा सामना करावा लागतो त्यावेळी  मराठवाडा फाउंडेशन नेहमीच  सहकार्य  करते  व  महाराष्ट्रातील विविध जिल्ह्यांमध्ये स्थलांतरित झालेले लोकांना एकत्र करण्याचे काम करण्यात आले आहे नक्कीच हे सर्व एकत्र येऊन एकमेकांचा आधार बनतील आणि शैक्षणिक क्षेत्रात सुद्धा एकमेकांना चांगल्या पद्धतीने सहकार्य करतील अशी अपेक्षा व्यक्त करतो  मराठवाडा सामाजिक फाऊंडेशन ला पुढील वाटचालीस शुभेच्छा देतो.",
  //     avatar: "/team/t12.jpeg",
  //   },
  //   {
  //     name: "मा. श्री दिनकर आण्णा पाटील ",
  //     role: "सरचिटणीस ( महाराष्ट्र राज्य) महाराष्ट्र नव निर्माण सेना",
  //     feedback:
  //       "मराठवाडा सामाजिक फाऊंडेशन हे मराठवाड्यातून नाशिक शहरात  स्थायिक झालेल्या  कामगार , विद्यार्थी, महिला, अनाथ अपंग,छोटे - मोठे उद्योग, व्यवसायिक यांच्यासाठी कार्यरत असुन, त्यांच्या साठी एक हक्काचे व्यासपीठ बनले आहे माझ्याकडे देखील काही अडचणी घेऊन आले असता त्यांच्या अडचणी सोडविल्या आहेत. मराठवाड्यातील नागरिक मोठ्या संख्येने  नाशिक पश्चिम मतदार संघात राहतात यापुढेही काही फाऊंडेशन ला जे काही सहकार्य लागेल ते मी नक्कीच करेल व पुढील वाटचालीस खूप खूप शुभेच्छा... ",
  //     avatar: "/images/dinkar.jpeg",
  //   },
  //   {
  //     name: "मा. राहुलदादा उत्तम बालवडकर",
  //     role: "उपाध्यक्ष राष्ट्रवादी काँग्रेस पार्टी - पुणे शहर",
  //     feedback:
  //       "मराठवाडा सामाजिक फाऊंडेशन च्या वतीने मी देखील त्यांच्या सोबत एकत्र मिळून सण, उत्सव, मोठ्या उत्साहात बालेवाडी, पुणे शहरात साजरा करत असतो. मी मागील वर्षी पावसाळ्यामध्ये मराठवाड्यातील बांधवांना छत्री वाटप केले .तसेच पुण्यश्लोक अहिल्यादेवी होळकर जयंती उत्सव साजरा करण्यात आला  व मकर संक्रात निमित्त महिला भगिनींचा हळदी-कुंकवाच्या कार्यक्रमा निमित्त प्रत्येक महिला भगिनींना गृह उपयोगी वस्तू भेट  देण्यात आले मराठवाड्यातील  बांधवांना काही सहकार्य लागल्यास नक्कीच सहकार्य करेल.मराठवाडा सामाजिक फाऊंडेशनचे कार्य प्रेरणादायी आहे त्यांच्या पुढील वाटचालीस शुभेच्छा..",
  //     avatar: "/images/rahul.jpeg",
  //   },
  // ];

  

  const newsData = [
    {
      title: "मराठवाडा सामाजिक फाऊंडेशनच मेळावा नाशिक येथे उत्साहात साजरा",
      date: "10 June 2025",
      description:
        "वंचित मुलांना डिजिटल शिक्षण साधने प्रदान करण्यासाठी आम्ही एक नवीन उपक्रम सुरू केला आहे.",
      image: "/satkar/480959928_2050426232036292_5835465465209799615_n.jpg",
    },
    {
      title: "मराठवाडा सामाजिक फाउंडेशनची बैठक",
      date: "28 May 2025",
      description:
        "आमच्या अलिकडच्या आरोग्य शिबिरात ५०० हून अधिक ग्रामस्थांना मोफत तपासणी आणि औषधे देण्यात आली.",
      image: "/satkar/481047677_2049414292137486_6396255060755539121_n.jpg",
    },
    {
      title: "ग्रामीण भागात वृक्षारोपण मोहीम",
      date: "15 May 2025",
      description:
        "शाश्वततेला चालना देण्यासाठी आम्ही दुष्काळग्रस्त गावांमध्ये १,००० झाडे यशस्वीरित्या लावली.",
      image: "/satkar/481076726_2050426475369601_6415716403700044015_n.jpg",
    },
  ];

  const images = [
    "/satkar/DSC_0094.JPG",
    "/satkar/DSC_0024.JPG",
    "/satkar/DSC_0024.JPG",
  ];

  const navItems = [
    {
      to: "/blogs",
      icon: "/images/blog.png",
      title: "ब्लॉग",
      description: "Read our latest posts",
    },
    {
      to: "/donation",
      icon: "/images/donation.png",
      title: "देणगी ",
      description: "Support our cause",
    },
    {
      to: "/membership",
      icon: "/images/regi.jpg",
      title: "सदस्य नोंदणी ",
      description: "Join our community",
    },
    {
      to: "/news",
      icon: "/images/news.png",
      title: "बातम्या",
      description: "Latest updates",
    },
    // {
    //   to: "talks",
    //   icon: "/images/talks.png",
    //   title: "Talks",
    //   description: "Inspiring speeches",
    // },
    {
      to: "/events",
      icon: "/images/polls.png",
      title: "कार्यक्रम",
      description: "Upcoming activities",
    },
  ];

  return (
    <div style={{ backgroundColor: "#fff2eb" }}>
      <Slider />

      <div className="curved-background py-4 rounded-bottom-5">
        <div className="container">
          <h2 className="text-start mb-5 fw-bold border-start border-4 ps-3 border-danger">
            मराठवाडा सामाजिक फाऊंडेशन मध्ये आपले स्वागत आहे
          </h2>
          <div className="row g-4 justify-content-center">
            {navItems.map((item, index) => (
              <div key={index} className="col-6 col-md-4 col-lg-2">
                <NavLink
                  to={item.to}
                  className="card h-100 bg-danger border-0 shadow-sm text-white"
                >
                  <div className="card-body text-center p-3">
                    <div className="icon-wrapper mb-3">
                      <img
                        width={80}
                        height={80}
                        src={item.icon}
                        alt={item.title}
                        className="img-fluid rounded-4 shadow-sm"
                        style={{ objectFit: "cover" }}
                      />
                    </div>
                    <h5 className="card-title fw-bold  text-white mb-2">
                      {item.title}
                    </h5>
                    {/* <p className="card-text text-white small mb-3">
                      {item.description}
                    </p> */}
                  </div>
                </NavLink>
              </div>
            ))}
          </div>
        </div>
      </div>

      <About />

      {/* projects count */}
      <section
        className="stats-section mb-5  py-5 border-bottom"
        style={{
          background:
            "linear-gradient(135deg,rgb(253, 224, 171),rgb(190, 50, 25),rgb(248, 220, 92))",
          color: "#fff",
        }}
      >
        <div className="container">
          <div className="row text-center">
            <div className="col-6 col-md-3 py-4">
              <h3 className="display-4 fw-bold text-white mb-0">
                {stats.years}+
              </h3>
              <h4 className="text-uppercase fw-semibold text-white mb-0">
                अनुभव
              </h4>
            </div>
            <div className="col-6 col-md-3 py-4">
              <h3 className="display-4 fw-bold text-white mb-0">
                {stats.members}+
              </h3>
              <h4 className="text-uppercase fw-semibold text-white mb-0">
                सदस्य{" "}
              </h4>
            </div>
            <div className="col-6 col-md-3 py-4">
              <h3 className="display-4 fw-bold text-white mb-0">
                {stats.programs}+
              </h3>
              <h4 className="text-uppercase fw-semibold text-white mb-0">
                कार्यक्रम
              </h4>
            </div>
            <div className="col-6 col-md-3 py-4">
              <h3 className="display-4 fw-bold text-white mb-0">
                {stats.volunteers}+
              </h3>
              <h4 className="text-uppercase fw-semibold text-white mb-0">
                एकूण स्वयंसेवक
              </h4>
            </div>
          </div>
        </div>
      </section>

      <div style={{ backgroundColor: "#FFF2EB" }}>
        {" "}
        <div className="container py-2">
          <h2 className="text-start mb-4 fw-bold border-start border-4 ps-3 border-primary">
            कार्यक्रम
          </h2>

          <Swiper
            modules={[Navigation, A11y]}
            spaceBetween={30}
            slidesPerView={1}
            navigation
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
              1064: {
                slidesPerView: 4,
                spaceBetween: 30,
              },
            }}
          >
            <div className="container row">
              {programs &&
                programs.map((item) => {
                  return (
                    <>
                      <SwiperSlide key={item.id}>
                        <div
                          style={{ height: "24rem" }}
                          className="card program-card border-0 rounded-4 position-relative"
                        >
                          <div className="position-relative">
                            <img
                              src={item.image}
                              className="card-img-top img-fluid"
                              alt={item.title}
                              style={{
                                height: "220px",
                                objectFit: "cover",
                              }}
                            />
                            <div className="overlay position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-25"></div>
                          </div>
                          <div className="card-body">
                            <h6 className="card-title fw-bold text-center">
                              {item.title}
                            </h6>
                            {/* <p className="card-text text-primary small mb-2">
                              📅 {item.date}
                            </p> */}
                            <p
                              className="card-text text-center text-muted"
                              style={{ textAlign: "justify" }}
                            >
                              {item.description}
                            </p>
                          </div>
                        </div>
                      </SwiperSlide>
                    </>
                  );
                })}
            </div>
          </Swiper>
        </div>
      </div>

      <div className="container py-3">
        <h2 className="text-start mb-5 fw-bold border-start border-4 ps-3 border-danger">
          ताज्या बातम्या
        </h2>
        <div className="row">
          <Swiper
            modules={[Navigation, A11y]}
            spaceBetween={30}
            slidesPerView={3} // Default to 3
            navigation
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              640: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            }}
          >
            <div className="container rowr">
              {news &&
                news.map((item) => {
                  return (
                    <>
                      <SwiperSlide key={item.id}>
                        <div
                          style={{ height: "20rem" }}
                          className="card program-card border-0 rounded-4 position-relative"
                        >
                          <div className="position-relative">
                            <img
                              src={item.image}
                              className="card-img-top img-fluid"
                              alt={item.title}
                              style={{
                                height: "220px",
                                objectFit: "cover",
                              }}
                            />
                            <div className="overlay position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-25"></div>
                          </div>
                          <div className="card-body">
                            <h6 className="card-title fw-bold text-center">
                              {item.title}
                            </h6>
                            {/* <p className="card-text text-primary small mb-2">
                              📅 {item.date}
                            </p> */}
                            {/* <p className="card-text text-center text-muted">
                              {item.description}
                            </p> */}
                          </div>
                        </div>
                      </SwiperSlide>
                    </>
                  );
                })}
            </div>
          </Swiper>
        </div>
      </div>

      <div>
        {" "}
        <div className="container py-3">
          <div className="row">
            <div className="col-md-10">
              <h2 className="text-start mb-5 fw-bold border-start border-4 ps-3 border-warning">
                आमची गॅलरी
              </h2>
            </div>
            <div className="col-md-2">
              {" "}
              <NavLink to="/gallery" className="btn btn-outline-danger">
                View All &nbsp; <FaLongArrowAltRight />
              </NavLink>
            </div>
          </div>
          <div className="masonry-grid">
            {images.map((src, index) => (
              <div className="masonry-item" key={index}>
                <img
                  src={src}
                  alt={`Gallery ${index + 1}`}
                  className="gallery-img"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="container py-3">
        <h2 className="text-start mb-5 fw-bold border-start border-4 ps-3 border-success">
          संस्थेबद्दलच्या प्रतिक्रिया
        </h2>
        <Swiper
          modules={[Navigation, A11y]}
          spaceBetween={30}
          slidesPerView={3} // Default to 3
          navigation
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
        >
          {testinomial &&
            testinomial.map((item) => (
              <SwiperSlide key={item.id}>
                <div
                  className="bg-white shadow-sm testimonial-card rounded-5  p-3 text-center"
                  style={{ height: "33rem" }}
                >
                  <img
                    src={item.image}
                    className="rounded-circle mx-auto mb-3"
                    alt={item.name}
                    width="100"
                    height="100"
                  />
                  <h5 className="mb-1">{item.title}</h5>
                  <p className="text-muted mb-2">{item.role}</p>
                  {/* <p className="text-muted mb-2">{item.role2}</p> */}
                  <p className="testimonial-text">“{item.descr}”</p>
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      </div>

      {/* events */}
      {/* <section className="container-xl mt-3">
        <div className="row">
          <div className="col-md-10 ">
            <h4 className=" my-4 text-uppercase">Trending on Our Portal</h4>
          </div>
        </div>
        <Swiper
          modules={[Navigation, A11y]}
          spaceBetween={40}
          slidesPerView={2}
          navigation
          breakpoints={{
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
        >
          <div className="col ">
            <SwiperSlide>
              <NavLink to="/internships">
                <img
                  src="/images/1.png"
                  alt=""
                  className="card-img-top rounded-4 "
                />
              </NavLink>
            </SwiperSlide>
            <SwiperSlide>
              <NavLink to="/jobs">
                <img
                  src="/images/2.png"
                  alt=""
                  className="card-img-top rounded-4"
                />
              </NavLink>
            </SwiperSlide>
            <SwiperSlide>
              <NavLink to="/merchants">
                <img
                  src="/images/3.png"
                  alt=""
                  className="card-img-top rounded-4"
                />
              </NavLink>
            </SwiperSlide>
          </div>
        </Swiper>
      </section> */}

      {/* <div className="container-xl mt-3 p-3">
        <div className="row">
          <div className="col-md-10 ">
            <h4 className="text-uppercase">Merchants / Organizations</h4>
          </div>
          <div className="col-md-2 text-center">
            <button className="btn btn-dark p-2 my-2">
              <NavLink
                to="/merchants"
                className="text-white text-decoration-none"
              >
                VIEW ALL <BsFillArrowRightCircleFill />
              </NavLink>
            </button>
          </div>
        </div>
        <Swiper
          modules={[Navigation, A11y]}
          spaceBetween={30}
          slidesPerView={1}
          navigation
          breakpoints={{
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1064: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
          }}
        >
          <div className="container row">
            {merchants &&
              merchants
                ?.filter((item) => item.status === "Approved")
                .map((item) => {
                  return (
                    <>
                      <SwiperSlide key={item.id}>
                        <div className="col card bg-light shadow-sm text-dark ">
                          <img
                            src={item.image}
                            alt=""
                            height={230}
                            className="card-img-top zoom-effect "
                          />
                          <div className="banner-1 p-3 text-dark">
                            <h6 className="text-uppercase fw-bold">
                              {item.shop_name}
                            </h6>
                            <NavLink
                              to={`/merchants/${item.id}`}
                              className="btn banner text-white btn-sm fw-bold mt-3 shadow"
                            >
                              Enquire Now
                            </NavLink>
                          </div>
                        </div>
                      </SwiperSlide>
                    </>
                  );
                })}

            {superadminmerchants &&
              superadminmerchants?.map((item) => {
                return (
                  <>
                    <SwiperSlide key={item.id}>
                      <div className="col card bg-light shadow-sm text-dark ">
                        <img
                          src={item.image}
                          alt=""
                          height={230}
                          className="card-img-top zoom-effect "
                        />
                        <div className="banner-1 p-3 text-dark">
                          <h6 className="text-uppercase fw-bold">
                            {item.shop_name}
                          </h6>
                          <NavLink
                            to={`/adminmerchants/${item.id}`}
                            className="btn banner text-white btn-sm fw-bold mt-3 shadow"
                          >
                            Enquire Now
                          </NavLink>
                        </div>
                      </div>
                    </SwiperSlide>
                  </>
                );
              })}
          </div>
        </Swiper>
      </div> */}
    </div>
  );
};

export default Home;
